import ContentSchema from './ContentSchema'

class PicoWordpress extends ContentSchema {
    static isMatch() {
        return !!window.Pico && !window.pico
    }

    static findContent(overrides) {
        const url = overrides?.url || PicoWordpress.getUrl()
        const author = overrides?.author || PicoWordpress.getAuthor()
        const title = overrides?.title || PicoWordpress.getTitle()
        const origin = overrides?.origin || PicoWordpress.getOrigin()
        // eslint-disable-next-line camelcase
        const resource_ref = overrides?.resource_ref || PicoWordpress.getResourceRef()

        return PicoWordpress.content({
            ...(window.Pico?.post || {}),
            author,
            origin,
            // eslint-disable-next-line camelcase
            resource_ref,
            title,
            url,
        })
    }
}

export default PicoWordpress
